import React, { useRef, useState } from 'react'

import cn from 'classnames'
import { navigate } from 'gatsby'
import ReCAPTCHA from 'react-google-recaptcha'

import api from '~/siteApi'

import * as st from '~/assets/styl/Newsletter.module.styl'
import { AnchorLink } from 'gatsby-plugin-anchor-links'

export default function Newsletter() {
  const [email, setEmail] = useState('')
  const [privacy, setPrivacy] = useState(false)
  const [communications, setCommunications] = useState(false)
  const recaptchaRef = useRef<ReCAPTCHA>()

  function handleChange(e) {
    setEmail(e.target.value)
  }

  function handleTermo(e) {
    setPrivacy(e.target.checked)
  }

  function handleComunicacao(e) {
    setCommunications(e.target.checked)
  }

  function handleSubmit(e) {
    e.preventDefault()

    recaptchaRef.current.executeAsync().then((recaptcha) => {
      recaptchaRef.current.reset()

      const bypass = process.env.GATSBY_RECAPTCHA_BYPASS
      const isDev = process.env.NODE_ENV === 'development'

      api('post', 'leads/newsletter', {
        email,
        privacy,
        consent: communications,
        recaptcha: isDev && bypass ? bypass : recaptcha,
      })
        .then(() => {
          setEmail('')
          navigate('/obrigado')
        })
        .catch((error) => {
          alert(
            error?.message ||
              'Não foi possível cadastrar seu e-mail. Tente novamente.'
          )
        })
    })
  }

  return (
    <section className={cn(st.newsletterContainer, 'page-width')}>
      <h2>Cadastre-se e fique sempre por dentro das novidades Dimas Sempre.</h2>
      <form onSubmit={handleSubmit}>
        <div className={st.inputWrapper}>
          <div className={st.emailInput}>
            <label>
              <input
                type="email"
                id="email"
                placeholder="Qual seu e-mail?"
                value={email}
                required
                onChange={handleChange}
              />
            </label>
          </div>
          <div className={st.privacy}>
            <label>
              <input
                id="use_terms_privacy"
                type="checkbox"
                name="termo"
                onChange={handleTermo}
                required
              />
              <small>
                Eu concordo em receber comunicações. Ao informar meus dados, eu
                concordo com a
                <AnchorLink to="/politica-de-privacidade/">
                  Política de privacidade
                </AnchorLink>
                e<AnchorLink to="/termos-de-uso/">Termos de uso</AnchorLink>
              </small>
            </label>
            <label>
              <input
                id="use_terms_comunicacao"
                type="checkbox"
                name="comunicacao"
                onChange={handleComunicacao}
                required
              />
              <small>
                Autorizo o Grupo Dimas a armazenar meus dados pessoais para
                enviar campanhas de marketing e informações sobre a empresa nos
                canais: Telefone, Email e SMS.
              </small>
            </label>
          </div>
        </div>
        {process.env.GATSBY_RECAPTCHA_KEY && (
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.GATSBY_RECAPTCHA_KEY}
            size="invisible"
          />
        )}
        <button type="submit">Enviar</button>
      </form>
    </section>
  )
}
